<template>
  <div>
    <div class="pricing">
      <svg class="pricing-curve" xmlns="http://www.w3.org/2000/svg" width="285" height="206.5" viewBox="0 0 285 206.5">
        <g id="Group_855" data-name="Group 855" transform="translate(-18 -26.5)">
          <g id="Group_854" data-name="Group 854">
            <text id="Below_Average" class="pricing-curve-1" data-name="Below Average" transform="translate(18 26.5)">
              <tspan x="0" y="12">{{columnOneLabel}}</tspan>
            </text>
            <text id="Good_Price" class="pricing-curve-1" data-name="Good Price" transform="translate(105 26.5)">
              <tspan x="25.866" y="12">{{columnTwoLabel}}</tspan>
            </text>
            <text id="Above_Average" class="pricing-curve-1" data-name="Above Average" transform="translate(216 26.5)">
              <tspan x="4.056" y="12">{{columnThreeLabel}}</tspan>
            </text>
          </g>
          <g id="Group_853" data-name="Group 853">
            <g id="Rectangle_42" class="pricing-curve-2" data-name="Rectangle 42">
              <path d="M0 0h285v185H0z" class="pricing-curve-12" transform="translate(18 48)"/>
              <path d="M.5.5h284v184H.5z" class="pricing-curve-13" transform="translate(18 48)"/>
            </g>
            <g id="Group_851" data-name="Group 851">
              <path id="Line_32" d="M0 0v48.5" class="pricing-curve-2" data-name="Line 32" transform="translate(105 48)"/>
              <path id="Line_33" d="M0 0v48.5" class="pricing-curve-2" data-name="Line 33" transform="translate(216 48)"/>
            </g>
            <g id="Group_850" data-name="Group 850">
              <path id="Path_226" d="M268.66 507.821h-55.45V371.742c10.06-16.013 25.36-31.3 44.17-35.3a.319.319 0 0 0 .09-.03 65.634 65.634 0 0 1 11.19-.967z" class="pricing-curve-3" data-name="Path 226" transform="translate(-108.039 -275.45)"/>
              <path id="Path_227" d="M213.21 371.875v136.56h-86.55v-11.35a101.025 101.025 0 0 0 52.69-48.58c10.59-21.22 17.08-44.24 27.65-65.47q1.83-3.675 3.87-7.25c.08-.13.15-.27.23-.4.67-1.17 1.38-2.34 2.11-3.51z" class="pricing-curve-4" data-name="Path 227" transform="translate(-107.66 -276.059)"/>
              <path id="Path_224" d="M268.66 507.821h55.45V371.742c-10.06-16.013-25.36-31.3-44.17-35.3a.319.319 0 0 1-.09-.03 65.634 65.634 0 0 0-11.19-.967z" class="pricing-curve-5" data-name="Path 224" transform="translate(-108.281 -275.45)"/>
              <path id="Path_225" d="M324.11 371.875v136.56h86.55v-11.35a101.025 101.025 0 0 1-52.69-48.58c-10.59-21.22-17.08-44.24-27.65-65.47q-1.83-3.675-3.87-7.25c-.08-.13-.15-.27-.23-.4-.67-1.17-1.38-2.34-2.11-3.51z" class="pricing-curve-4" data-name="Path 225" transform="translate(-108.66 -276.059)"/>
              <path id="Line_35" d="M0 0v135.876" class="pricing-curve-6" data-name="Line 35" transform="translate(216 96.5)"/>
              <path id="Line_34" d="M0 0v135.876" class="pricing-curve-6" data-name="Line 34" transform="translate(105 96.5)"/>
              <g id="Ellipse_27" class="pricing-curve-7" data-name="Ellipse 27" transform="translate(99 90.5)">
                <circle cx="6" cy="6" r="6" class="pricing-curve-12"/>
                <circle cx="6" cy="6" r="5" class="pricing-curve-13"/>
              </g>
              <g id="Ellipse_28" class="pricing-curve-7" data-name="Ellipse 28" transform="translate(210 90.5)">
                <circle cx="6" cy="6" r="6" class="pricing-curve-12"/>
                <circle cx="6" cy="6" r="5" class="pricing-curve-13"/>
              </g>
            </g>
            <g id="Group_852" data-name="Group 852">
              <text id="Good_Price-2" class="pricing-curve-8" data-name="Good Price" transform="translate(227 87.5)">
                <tspan x="0" y="14">Good </tspan><tspan x="0" y="31">Price</tspan>
              </text>
              <text id="Great_Price" class="pricing-curve-9" data-name="Great Price" transform="translate(33 87.5)">
                <tspan x="23.929" y="14">Great </tspan><tspan x="27.576" y="31">Price</tspan>
              </text>
              <text id="_3_000" class="pricing-curve-10" data-name="£3,000" transform="translate(117 161.5)">
                <tspan v-if="averagePriceAvailable" :x="xValue" y="20">{{pricingCurrency}}{{variancePriceFormatted}}</tspan>
                <tspan v-else :x="xValue" y="20">{{variancePriceFormatted}}</tspan>
              </text>
              <text id="Typical_Variance" class="pricing-curve-11" data-name="Typical Variance" transform="translate(117 123.5)">
                <tspan x="21.975" y="14">Typical </tspan><tspan x="16.315" y="32">Variance</tspan>
              </text>
            </g>
          </g>
        </g>
      </svg>
      <small class="pricing__smallprint">
        {{pricingSmallPrint}}
      </small>
    </div>
    <div class="pricing-result">
      <div class="pricing-result__block">
        <div class="pricing-result__label">
          {{savingLabel}}
        </div>
        <div class="pricing-result__result pricing-result__result--average">
          <span v-if="averagePriceAvailable">{{pricingCurrency}}</span>{{savingPrice}}
        </div>
      </div>
      <div class="pricing-result__block">
        <div class="pricing-result__label">
          {{rrpLabel}}
        </div>
        <div class="pricing-result__result pricing-result__result--real">
          <span v-if="averagePriceAvailable">{{pricingCurrency}}</span>{{mrpPrice}}
        </div>
      </div>
    </div>
    <div v-if="!averagePriceAvailable && averagePercentSavingAvailable" v-html="averagePercentSavingText" class="pricing-message pricing-message__text"></div>
    <div v-if="!averagePercentSavingAvailable && !averagePriceAvailable" v-html="noAveragePriceLabel" class="pricing-message pricing-message__text"></div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { tokenService } from '../../services/TokenService';

const VehicleModule = namespace('vehicleModule');

@Component
export default class DerivativePricingComponent extends Vue {
  @VehicleModule.Getter public averagePriceAvailable;

  @VehicleModule.Getter public averagePrices;

  @Prop({ default: 'Below Average' })
  public columnOneLabel!: string;

  @Prop({ default: 'Good Price' })
  public columnTwoLabel!: string;

  @Prop({ default: 'Above Average' })
  public columnThreeLabel!: string;

  @Prop({ default: 'RRP' })
  public rrpLabel!: string;

  @Prop({ default: 'Great Price' })
  public savingLabel!: string;

  @Prop({ default: '£' })
  public pricingCurrency!: string;

  @Prop({ default: '*Our great price is based on market research over the last 3 months. This does not represent a quote or offer.' })
  public pricingSmallPrint!: string;

  @Prop({ default: 'We don\'t currently have any discount price data for the exact vehicle you\'ve selected, however we are typically seeing <span>discounts of up to averagePercent on vehicleName cars.</span>  We\'ll now work to get you a great quote.' })
  public averagePercentSavingLabel!: string;

  @Prop({ default: 'We don\'t have specific discount prices for this specific car right now but can help you get an accurate quotation from a local dealership. We’ll ensure someone contacts you shortly to help' })
  public noAveragePriceLabel!: string;

  public get savingPrice(): string {
    if (!this.averagePriceAvailable) {
      return 'N/A';
    }

    return this.averagePrices[1]
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  public get mrpPrice(): string {
    if (this.averagePrices[0] === 0) {
      return 'N/A';
    }
    return this.averagePrices[0]
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  public get variancePrice(): number {
    if (!this.averagePriceAvailable) {
      return 0;
    }

    return this.averagePrices[0] - this.averagePrices[1];
  }

  public get variancePriceFormatted(): string {
    if (!this.averagePriceAvailable) {
      return 'N/A';
    }
    return this.variancePrice
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  public get xValue(): string {
    if (this.variancePrice < 1000 && this.averagePriceAvailable) {
      return '19.75';
    }

    if (this.variancePrice < 10000 && this.averagePriceAvailable) {
      return '12.75';
    }

    if (!this.averagePriceAvailable) {
      return '23.75';
    }

    return '7';
  }

  public get averagePercentSavingText(): string {
    return tokenService.replaceToken(this.averagePercentSavingLabel);
  }

  public get averagePercentSavingAvailable(): boolean {
    return this.$store.getters['vehicleModule/averagePercentSavingAvailable'];
  }
}
</script>
